export enum AppRoutingPaths {
  Empty = '',
  Full = 'full',
  Onboarding = 'onboarding',
  Business = 'business',
  DocumentUpload = 'documents-upload',
  MerchantSaved = 'merchant-saved',
  ThankYou = 'thank-you',
  Contact = 'contact',
  NotFound = 'not-found',
  DocumentUploadRedirect = 'onboarding/business/documents-upload',
  WildCard = '**'
}
